// Code common to all site pages lives here

/* global jQuery */

const $             = jQuery;   // jQuery loaded via WordPress enqueue process
const ScrollReveal  = require('scrollreveal');
const dc            = require('./utilities/device-check');
const events        = require('./utilities/events');
const overlayMenu   = require('./components/overlay-menu');
const dishMenu      = require('./components/dishes-menu');
const heroSlider    = require('./components/hero-slider');
const productSlider = require('./components/product-slider');
const headerVis     = require('./components/header-vis');


/**
 * Check to see if user is on a mobile or tablet device (or not).
 * Set a marker class on the body.
 */
function checkTouch() {
    if (dc.isMobileOrTablet()) {
        $('body').addClass('is-touch');
    } else {
        $('body').addClass('no-touch');
    }
}


/**
 * Initialize any form elements found in the page.  
 */
function initFormElements() {

    // Add marker class to any fields that are not empty. This is 
    // needed in instances where an input and/or label is 
    // styled differently when it contains content.
    let fieldTypes = 'input[type=text], input[type=tel], input[type=email], \
        input[type=password], input[type=search], input[type=url], \
        input[type=number], textarea';

    // Run an initial check...
    $.each($(fieldTypes), (index, el) => {
        checkForEmpty($(el));
    });
    // Then set up a listener for any changes to the fields
    $(fieldTypes).on('input propertychange paste', (evt) => {
        checkForEmpty($(evt.target));
    });

    function checkForEmpty($el) {
        if ($el.val() !== '') {
            $el.addClass('is-not-empty');
        } else {
            $el.removeClass('is-not-empty');
        }
    }

}


/**
 * Set up our overlay menu, including handlers for the menu button (hamburger), 
 * and the close button within it.
 */
function initOverlayMenu() {
    let $overlay = $('.overlay-menu');
    if ($overlay.length) {
        overlayMenu.init();
    }
}

/**
 * Set up our (icon-based) dish filter menu.
 */
function initDishMenu() {
    let $menu = $('.site-header__dish-filter-menu');
    if ($menu.length) {
        dishMenu.init();
    }
}

/**
 * Init any slick sliders in the current page
 */
function initSliders() {
    // Hero sliders
    let $heroSliders = $('.hero-slider');
    if ($heroSliders.length) {
        heroSlider.init($heroSliders);
    }
    // Product sliders
    let $productSliders = $('.product-slider');
    if ($productSliders.length) {
        productSlider.init($productSliders);
    }
}

/**
 * Initialize our scroll reveal animations.  Any element with a
 * reveal class on it will be hidden until it scrolls
 * into view.  Class/animation options:
 *   - js-reveal | js-reveal-bottom -- item slides into view from below
 *   - js-reveal-left -- item slides into view from the left
 *   - js-reveal-right -- item slides into view from the right
 *   - js-reveal-static -- item fades in - no motion
 *   - js-reveal-on-enter -- don't wait for 30% of item to be in frame --
 *                           reveal occurs as soon as element enters frame
 */
function initScrollReveal() {
    // Set defaults
    window.sr = ScrollReveal({
        duration: 1500,
        distance: '100px',
        viewFactor: 0.3,
        scale: 1,
        beforeReveal: function(domEl) {
            $('body').trigger(events.REVEAL_START, domEl);
        },
        afterReveal: function (domEl) {
            $('body').trigger(events.REVEAL_COMPLETE, domEl);
        }
    });
    window.sr.reveal('.js-reveal, .js-reveal-bottom');
    window.sr.reveal('.js-reveal-left',
        { 
            origin: 'left'
        });
    window.sr.reveal('.js-reveal-right',
        {
            origin: 'right',
        });
    window.sr.reveal('.js-reveal-static',
        {
            distance: '0',
        });
    window.sr.reveal('.js-reveal-on-enter',
        {
            delay:500,
            viewFactor:0,
        });
    window.sr.reveal('.js-reveal-static-on-enter',
        {
            delay: 500,
            viewFactor: 0,
            distance: '0',
        });
}

function initHeaderVis() {
    let $header = $('.site-header');
    if ($header.length) {
        headerVis.init($header);
    }
}


exports.init = function() {
    // Do common initialization...
    checkTouch();
    initFormElements();
    initOverlayMenu();
    initDishMenu();
    initSliders();
    initScrollReveal();
    initHeaderVis();
};
